import { fg } from '@atlaskit/platform-feature-flags';

import { getPlatformFeatureFlags } from './getFeatureFlags';

export const getSrcUrl = (
	tunnels: { resourceKey: string; tunnelUrl: string }[],
	extensionResource: string,
	defaultUrl: string,
	urlSafeContext: string,
) => {
	const matchTunnel = tunnels.find((tunnel) => tunnel.resourceKey === extensionResource);

	const platformFeatureFlags = getPlatformFeatureFlags();

	const queryParams = new URLSearchParams({
		...(platformFeatureFlags.length > 0
			? { platformFeatureFlags: platformFeatureFlags.join(',') }
			: {}),
		// when tunnelling, pass hostname into query param to be passed into CSP
		...(matchTunnel && !fg('forge-include-hostname-in-url-path')
			? { hostname: window.location.hostname }
			: {}),
	}).toString();

	const query = queryParams ? `?${queryParams}` : '';

	if (fg('forge-include-hostname-in-url-path')) {
		const contextPathParts = `_hostname_${window.location.hostname}/ctx_${urlSafeContext}`;

		if (matchTunnel) {
			const { tunnelUrl } = matchTunnel;
			return tunnelUrl.endsWith('/')
				? `${tunnelUrl}${contextPathParts}/${query}`
				: `${tunnelUrl}/${contextPathParts}/${query}`;
		}
	}

	if (matchTunnel) {
		return `${matchTunnel.tunnelUrl}${query}`;
	}
	return `${defaultUrl}${query}`;
};
